import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../../layouts/dashboard/default"));
const AllTargetSources = lazy(() => import("../pages/all-target-sources"));

export const TargetManagementRouter = [
  {
    path: "/master-management/target-source",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "all",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllTargetSources />
          </Suspense>
        ),
      },
    ],
  },
];
